<template>
  <div class="home" :style="{ marginTop: isEmptyAuctionsList ? '200px' : null }">
    <div v-if="!isEmptyAuctionsList" class="page-title auction-list-title">
      Auctions
    </div>
    <div v-if="!isEmptyAuctionsList">
      <v-layout justify-end row align-center style="width: 70%; margin: 0 auto; cursor: pointer">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click.prevent="clearFilter" light>clear</v-icon>
          </template>
          <span>Clear all filter</span>
        </v-tooltip>
      </v-layout>
      <br />
      <div class="filtering">
        <v-layout
          row
          wrap
          no-gutters
          class="auction-list-filter-row"
          :style="auctionListFilterGridStyle"
        >
          <v-flex xs12 class="clerable-input">
            <v-text-field
              @input="filterAuctionsByDescription"
              v-model="filtering.description"
              hide-details
              :placeholder="auctionListHeaderLabels.TITLE"
              class="filter-date ma-0 pa-0"
              @blur="filterAuctions"
              @keyup.enter="filterAuctions"
              @click:append="clearDescription"
              :append-icon="filtering.description ? 'clear' : ''"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 class="text-center clerable-input">
            <v-select
              @change="setStatus"
              hide-details
              class="filter-date ma-0 pa-0"
              v-model="filtering.choosedStatus"
              :items="auctionStatus"
              item-text="text"
              item-value="value"
              :placeholder="auctionListHeaderLabels.STATUS"
              @click:append="clearStatusFilter"
              :append-icon="filtering.choosedStatus ? 'clear' : ''"
            >
            </v-select>
          </v-flex>
          <v-flex xs12 class="datepickers-filter clerable-input">
            <v-menu
              ref="menu"
              v-model="menu"
              :nudge-right="50"
              :max-width="290"
              transition="scale-transition"
              offset-y
            >
              <template #activator="{ on }">
                <v-text-field
                  @change="clearFilterDates"
                  readonly
                  class="filter-date ma-0 pa-0"
                  hide-details
                  v-model="dates"
                  :placeholder="auctionListHeaderLabels.STARTING_DATE"
                  @click.prevent="dates = ''"
                  @click:append="clearDateFilter"
                  :append-icon="dates ? 'clear' : ''"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker @change="clickFilterDate" v-model="dates" no-title scrollable>
              </v-date-picker>
            </v-menu>
            <!-- <v-icon v-if="dates !==''" @click.prevent="clearDateFilter" class="clear-icon clear-icon--date" light>clear</v-icon> -->
          </v-flex>
          <v-flex xs12 class="text-center clerable-input">
            <v-select
              @change="setAuctionType"
              class="filter-date ma-0 pa-0"
              v-model="filtering.choosedType"
              :items="auctionType"
              hide-details
              item-text="text"
              item-value="value"
              :placeholder="auctionListHeaderLabels.TYPE"
              @click:append="clearTypeFilter"
              :append-icon="filtering.choosedType ? 'clear' : ''"
            >
            </v-select>
          </v-flex>
          <v-flex xs12 class="clerable-input pr-md-0">
            <v-text-field
              @input="filterAuctionsByStartingPrice"
              v-model="filtering.priceFrom"
              hide-details
              :placeholder="auctionListHeaderLabels.STARTING_PRICE"
              class="filter-date ma-0 pa-0"
              @blur="filterAuctions"
              @keyup.enter="filterAuctions"
              @click:append="clearStartingPrice"
              :append-icon="filtering.priceFrom ? 'clear' : ''"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <p class="header-subtitle" v-if="!auctions.length">
      {{
        auctions.length === 0 && isEmptyAuctionsList
          ? 'Auctions have not yet been created.'
          : 'No auction found with these criteria.'
      }}
    </p>
    <div v-if="!auctions.length">
      <v-btn @click="$router.push({ name: 'auctionCreate' })" large
        ><v-icon light>add</v-icon> Create auction</v-btn
      >
    </div>
    <div v-if="error">
      {{ error }}
    </div>
    <v-data-table
      v-if="auctions.length"
      class="listing elevation-1"
      :items-per-page="auctionsPerPage"
      :headers="headers"
      :items="Array.from(auctions)"
      hide-default-footer
      @update:options="handleTableUpdateOptions"
    >
      <template v-slot:item="{ item }">
        <tr v-if="item">
          <td
            @click="toAuctionDetails(item.id)"
            class="text-left link"
            :class="getStatusClass(item.status)"
          >
            <a style="font-weight: 600; color: #2e7f89">{{ item.title }}</a
            ><br />
            <span
              v-if="item.description"
              class="auc-description"
              :style="{ height: item.description.length > 60 ? 'calc(14px * 2)' : 'auto' }"
            >
              {{ item.description }}
            </span>
          </td>
          <td class="text-left">{{ auctionStatusByKey[item.status] }}</td>
          <td v-if="item.auctionDate" class="text-left" style="white-space: nowrap">
            {{ item.auctionDate | moment('DD.MM.YYYY hh:mm') }}
          </td>
          <td v-else>-</td>
          <td class="text-left">{{ auctionTypeByKey[item.procurementMethodType] }}</td>
          <td class="text-left">
            {{ formatCurrencyAmount(item.startingPrice, item.currency, { prefixSymbol: true }) }}
          </td>
        </tr>
      </template>
    </v-data-table>
    <br v-if="auctions.length" />
    <div v-if="!isEmptyAuctionsList && auctions.length" class="text-xs-center">
      <v-pagination @input="filterAuctions" v-model="page" :length="auctionCount"></v-pagination>
    </div>
    <br />
  </div>
</template>

<script>
import utils from '@/utils/utils.js';
import AuctionsService from '@/services/AuctionsService';
import Vue from 'vue';
import { formatCurrencyAmount } from '@/utils/numberFormat';
import debounce from 'debounce';
import _ from 'lodash';
import { mapActions, mapState } from 'vuex';
import {
  AUCTION_STATUS_LABELS,
  AUCTION_TYPE_LABELS,
  AUCTION_TYPE_OPTIONS,
  AUCTION_STATUS_OPTIONS,
  DEFAULT_AUCTION_STATUS_FILTER,
  DEFAULT_AUCTION_TYPE_FILTER,
  ACTIVE_TENDERING_STATUS,
  UNSUCCESSFUL_STATUS,
  AUCTION_LIST_HEADER_LABELS,
  AUCTION_LIST_HEADERS,
  AUCTION_LIST_ORDER_BY_API,
  AUCTION_LIST_DEFAULT_ORDER_BY,
} from '@/constants/auction';
import { getAuctionStatusClass } from '@/utils/auctionStatusUi';

export default {
  name: 'auctionList',
  data: function () {
    return {
      auctionStatusByKey: {
        ...AUCTION_STATUS_LABELS,
      },
      auctionTypeByKey: {
        ...AUCTION_TYPE_LABELS,
      },
      auctionType: AUCTION_TYPE_OPTIONS,
      auctionStatus: AUCTION_STATUS_OPTIONS,
      auctionListHeaderLabels: AUCTION_LIST_HEADER_LABELS,
      filtering: {
        description: '',
        status: [...DEFAULT_AUCTION_STATUS_FILTER],
        choosedStatus: '',
        type: [...DEFAULT_AUCTION_TYPE_FILTER],
        choosedType: '',
        choosedRangeOfStartDates: [],
        priceFrom: '',
      },
      page: 1,
      auctionsPerPage: 10,
      auctionCount: 1,
      sortDesc: false,
      sortBy: '',
      headers: [...AUCTION_LIST_HEADERS],
      isAuctionActive: false,
      auctions: [],
      error: '',
      dates: '',
      menu: false,
      isEmptyAuctionsList: false,
      pageCount: 0,
    };
  },

  watch: {
    sortDesc() {
      this.filterAuctions();
    },
    sortBy() {
      this.filterAuctions();
    },
    filtering(newValue) {
      let config = {};
      if (newValue === 'owned' && this.loginInfo.isLogged) {
        config = utils.getAuthorizeAxiosConfig(this.loginInfo.accessToken);
      }
      AuctionsService.filterAuction(this.filtering, config)
        .then((response) => {
          this.auctionCount = Math.ceil(response.data.count / this.auctionsPerPage);
          this.auctions = response.data.results;
        })
        .catch((error) => {
          this.error = error.response.statusText;
        });
    },
  },
  created: function () {
    this.inspectToken().then(() => {
      this.getAuctions(this.page, this.auctionsPerPage);
    }),
      (this.filterAuctionsByDescription = debounce(this.filterAuctionsByDescription, 400));
    this.filterAuctionsByStartingPrice = debounce(this.filterAuctionsByStartingPrice, 400);
  },

  computed: {
    ...mapState(['loginInfo']),
    orderBy() {
      if (!this.sortBy) return AUCTION_LIST_DEFAULT_ORDER_BY;
      const apiOrderBy = AUCTION_LIST_ORDER_BY_API[this.sortBy];
      return apiOrderBy || AUCTION_LIST_DEFAULT_ORDER_BY;
    },
    /** Same column fractions as `headers[].width` → aligns filter inputs with table columns (desktop). */
    auctionListFilterGridStyle() {
      return {
        gridTemplateColumns: AUCTION_LIST_HEADERS.map((h) => h.width).join(' '),
      };
    },
  },

  methods: {
    ...mapActions(['inspectToken', 'getUserInfo', 'setLoading']),
    formatCurrencyAmount,
    handleTableUpdateOptions(data) {
      this.sortDesc = data.sortDesc[0];
      this.sortBy = data.sortBy[0];
    },
    inputDateInFiltering() {
      if (this.dates.length === 10) {
        this.clickFilterDate();
      }
    },
    filterAuctionsByDescription() {
      if (this.filtering.description.length >= 3) {
        this.filterAuctions();
      }
    },
    filterAuctionsByStartingPrice() {
      if (this.filtering.priceFrom.length >= 3) {
        this.filterAuctions();
      }
    },
    clearFilterDates() {
      this.filtering.choosedRangeOfStartDates = [];
      this.filterAuctions();
    },
    clearDescription() {
      this.filtering.description = '';
      this.filterAuctions();
    },
    clearStartingPrice() {
      this.filtering.priceFrom = '';
      this.filterAuctions();
    },
    clearDateFilter() {
      this.dates = '';
      this.filtering.choosedRangeOfStartDates = [];
      this.filterAuctions();
    },
    clickFilterDate() {
      this.filtering.choosedRangeOfStartDates = [];
      this.filtering.choosedRangeOfStartDates.push(this.dates);
      this.filtering.choosedRangeOfStartDates.push(Vue.moment().format('YYYY-MM-DD'));
      this.filterAuctions();
    },
    clearFilter() {
      this.filtering = {
        description: '',
        status: [...DEFAULT_AUCTION_STATUS_FILTER],
        choosedStatus: '',
        type: [...DEFAULT_AUCTION_TYPE_FILTER],
        choosedType: '',
        priceFrom: '',
      };
      this.dates = '';
      this.filtering.choosedRangeOfStartDates = [];
    },
    clearStatusFilter() {
      this.filtering.choosedStatus = '';
      this.filterAuctions();
    },
    clearTypeFilter() {
      this.filtering.choosedType = '';
      this.filterAuctions();
    },
    setStatus(e) {
      this.filtering.choosedStatus = e;
      this.filterAuctions();
    },
    setAuctionType(e) {
      this.filtering.choosedType = e;
      this.filterAuctions();
    },
    filterAuctions() {
      let clonedDates = _.cloneDeep(this.filtering.choosedRangeOfStartDates);
      let sortedDates = _.orderBy(
        clonedDates,
        function (o) {
          return new Vue.moment(o).format('YYYYMMDD');
        },
        ['asc']
      );
      let filter = {
        description: this.filtering.description,
        status: this.filtering.choosedStatus,
        procurement_method_type: this.filtering.choosedType,
        date_from: sortedDates[0],
        date_to: sortedDates[1],
        price_from: this.filtering.priceFrom,
        order_by: this.orderBy,
        direction: this.sortDesc ? 'desc' : 'asc',
      };
      this.getAuctions(this.page, this.auctionsPerPage, filter);
    },
    getAuctions(page, itemsPerPage, filter) {
      AuctionsService.filterAuction(page, itemsPerPage, filter)
        .then((response) => {
          this.pageCount = response.data.count;
          this.auctionCount = Math.ceil(response.data.count / itemsPerPage);
          this.auctions = response.data.results;
          if (this.auctions.length === 0) {
            if (!filter) {
              this.isEmptyAuctionsList = true;
            } else {
              this.isEmptyAuctionsList = false;
            }
          }
          this.setLoading({ show: false, text: '' });
        })
        .catch(() => {
          this.setLoading({ show: false, text: '' });
        });
    },
    toAuctionDetails(id) {
      this.$router.push({ path: 'auctions/' + id });
    },
    getStatusIcon(status) {
      if (status === UNSUCCESSFUL_STATUS) {
        return 'cancel';
      } else if (status === ACTIVE_TENDERING_STATUS) {
        return 'update';
      } else {
        return '';
      }
    },
    getStatusClass(status) {
      return getAuctionStatusClass(status, 'default-status');
    },
    removeAuction(auctionID, index) {
      AuctionsService.removeAuction(auctionID)
        .then(() => {
          this.auctions.splice(index, 1);
          this.getUserInfo();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss">
.home {
  
}

.auction-list-title {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}
.active-item {
  background: #f2f5f5 !important;
  border-left: 5px solid #b8baba !important;
}
.status-unsuccess {
  border-left: 5px solid #d81c1c9e !important;
}
.activeTendering {
  border-left: 5px solid #1b630896 !important;
}
.default-status {
  border-left: 5px solid #007781 !important;
}
.listing {
  width: 70%;
  margin: 0 auto;

  ::v-deep .v-data-table table {
    table-layout: fixed;
    width: 100%;
  }
}

@media (min-width: 1024px) {
  .filtering .auction-list-filter-row.layout {
    display: grid !important;
    flex-wrap: nowrap !important;
    align-items: start;
  }
}

@media (max-width: 959px) {
  .filtering .auction-list-filter-row.layout {
    display: flex !important;
    flex-direction: column;
    grid-template-columns: none !important;
  }
}
.v-list__tile__title {
  
  font-size: 12px !important;
}
.list-item {
  padding: 7px 7px 7px 20px;
  display: flex;
  width: 700px;
  margin: auto;
  margin-bottom: 15px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  background: #ffffff;
  border-left: 5px solid #2e7f89;

  .status {
    color: #216169;
    font-size: 16px;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  a {
    text-decoration: none;
  }
  img {
    width: 29px;
    height: 29px;
  }
  .item-title {
    display: grid;
    height: auto;
    min-height: 40px;
    align-items: center;
    text-align: left;
    text-decoration: none;
    color: #216169;
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 0 17px;
  }
  .event-item {
    margin-right: 12px;
    img {
      height: 18px;
      width: 18px;
      cursor: pointer;
      margin-right: 11px;
    }
    .last-img {
      margin-right: 0;
    }
  }
}

.filter,
.filter-date .v-input__slot {
  width: 100%;
  padding: 8px;
  background: #ffffffa3;
  height: 36px;
}

.theme--light.v-input input::placeholder,
.theme--light.v-input textarea::placeholder {
  color: black;
}

.theme--light.v-input input::-webkit-input-placeholder,
.theme--light.v-input textarea::-webkit-input-placeholder {
  color: black;
  opacity: 0.47;
}

.filter-date .v-input__slot {
  padding: 0 8px;
}

.filter-date {
  input {
    font-size: 0.8rem !important;
  }
}

.filter.starting-price,
.filter.description {
  border-bottom: 1px solid darkgrey;
}

.filter-date .v-input__slot::before,
.filter--combobox .v-input__slot::before {
  border-color: darkgrey !important;
}

.v-overflow-btn.filter--combobox .v-input__control::before {
  content: none;
}

.filtering {
  .v-text-field .v-input__append-inner {
    .v-icon {
      font-size: 16px !important;
      color: darkgrey !important;
    }
    margin-top: 6px !important;
  }
}

.filtering .flex {
  padding-right: 5px;
  font-weight: 400;
  font-size: 12px;
  height: 100%;
  margin-bottom: 10px;
}

.filtering {
  box-sizing: border-box;
}

.v-select__selections {
  margin-top: auto;
}

.filtering {
  width: 70%;
  margin: 0 auto;
}
.filter-description.v-text-field,
.filter-starting-price.v-text-field {
  padding-top: 0;
  margin-top: 0;
  font-size: 12px;
  font-weight: 400;
}
.datepickers-filter {
  .v-text-field {
    padding-top: 0;
    margin-top: 0;
    font-size: 12px;
    font-weight: 400;
  }
  .v-input__append-inner {
    margin-top: auto;
    margin-bottom: auto;
    margin-right: -7px !important;
    .v-icon {
      font-size: 16px;
    }
  }
}

.clerable-input {
  position: relative;
}

.clear-icon {
  position: absolute;
  top: 50%;
  bottom: 50%;
  right: 30px;
  font-size: 20px;
}

.v-overflow-btn .v-input__append-inner {
  margin-right: -23px;
  height: 100%;
  .v-input__icon {
    flex: 0;
  }
}

.filter--combobox {
  &.my-2 {
    margin-bottom: 0 !important;
  }
  .v-select__slot {
    background: #ffffffa3;
    label {
      font-size: 12px;
      font-weight: 400;
    }
  }
}

.filter--combobox.type .v-input__slot,
.filter--combobox.status .v-input__slot {
  .v-select__selection {
    font-size: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
    height: 1.4em;
    white-space: nowrap;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 30px;
    margin-left: 8px !important;
  }
}

.filter--combobox.v-overflow-btn .v-label {
  margin-left: 8px;
}

.v-overflow-btn .v-select__slot {
  height: 36px;
}

.filter--combobox {
  width: 100%;
  margin-top: 0 !important;
  margin-left: auto;
  margin-right: auto;
}

.filtering .v-text-field input {
  margin-right: 0px;
}

.filtering .v-text-field.filter-date-specific input {
  margin-right: 10px;
  & .filter-date {
    &:last-child {
      padding-right: 0 !important;
    }
  }
}

.filtering {
  .filter-date {
    &:last-child {
      padding-right: 0 !important;
    }
  }
}

.auc-description {
  overflow: hidden;
  line-height: 14px;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.link {
  cursor: pointer;
}

img[alt='remove'] {
  margin-right: 0 !important;
}

.list-item .event-item img {
  vertical-align: middle;
}

.filter-select {
  margin: auto;
}

.filtering .v-input__slot {
  margin-bottom: 0;
}

@media (max-width: 500px) {
  .listing {
    width: 98%;
  }
}
@media (max-width: 960px) {
  .filter,
  .filter--combobox {
    margin-bottom: 10px;
  }
}
@media (min-width: 960px) and (max-width: 1300px) {
  .filter,
  .filter--combobox {
    width: 100%;
  }
}
</style>
